import { useEffect, useMemo, useState } from "react";
import { FindItemIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { TextInput } from "../../../components/textInput/textInput";
import { KnowledgeButton } from "./adminKnowledgeButton";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useParams } from "react-router";
import KnowledgeAPI from "../../../api/KnowledgeAPI";
import {
    closestCenter,
    DndContext,
    KeyboardSensor,
    PointerSensor,
    TouchSensor,
    useSensor,
    useSensors
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { restrictToWindowEdges, restrictToVerticalAxis } from "@dnd-kit/modifiers"

import styles from "./adminKnowledgeBasePage.module.css";
import { Separator } from "../../../components/separator/separator";

export const AdminKnowledgeBasePage = () => {
    const { cafeId } = useParams();

    const openPage = useOpenPage();
    const [materials, setMaterials] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        if (!cafeId) return;
        KnowledgeAPI
            .fetchAdminMaterials(cafeId)
            .then(setMaterials)
            .catch(console.error)
    }, [cafeId]);

    const filteredMaterials = useMemo(() => materials.filter(el => el.title.toLowerCase().includes(search.trim().toLowerCase())), [materials, search]);

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                delay: 150,
                tolerance: 5,
            },
        })
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (active.id !== over.id) {
            const oldIndex = materials.findIndex(el => el.id === active.id);
            const newIndex = materials.findIndex(el => el.id === over.id);
            const newArray = arrayMove(materials, oldIndex, newIndex);

            const curId = active.id;
            const newPosition = newArray.findIndex(el => el.id === curId);
            const prevId = newPosition > 0 ? newArray[newPosition - 1].id : null;
            const nextId = newPosition < newArray.length - 1 ? newArray[newPosition + 1].id : null;

            KnowledgeAPI
                .changeOrder(curId, prevId, nextId)
                .catch(console.error);

            setMaterials(newArray);
        }
    };

    return (
        <DndContext sensors={sensors} modifiers={[restrictToVerticalAxis, restrictToWindowEdges]} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <AdminHeader title="База знаний" />

            <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />

            <SortableContext items={filteredMaterials} strategy={verticalListSortingStrategy}>
                <div className={styles.materials_container}>
                    {filteredMaterials.map((data) => (
                        <KnowledgeButton key={data.id} id={data.id} text={data.title} imgSrc={data.icon} cafeId={data.cafeId} link={`${data.id}`} />
                    ))}
                </div>
            </SortableContext>

            <Separator />

            <Button
                fixed
                text="Добавить категорию"
                onClick={openPage(`add`)}
            />
        </DndContext>
    )
}
